import styled from '@emotion/styled'

export const Input = styled.input`
  border: 1px solid lightgray;
  width: 100%;
  border-radius: 4px;
  padding: 0.8rem;

  &:focus {
    outline: none;
    border-color: lightgray;
  }
`
